import React from "react";
import "../css/Projects.css";
import projects from "../data/projects.data";

function ProjectImage({ project }) {
  const [failed, setFailed] = React.useState(false);
  const hasImage = project.image && !failed;

  return (
    <div className={`projectImageFrame projectImageFrame-${project.tone || "neutral"}`}>
      {hasImage ? (
        <img
          src={project.image}
          alt={project.imageAlt || `${project.title} preview`}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="projectImageFallback">
          <span>{project.status || "Preview"}</span>
          <strong>{project.title}</strong>
          <small>Application screenshot</small>
        </div>
      )}
    </div>
  );
}

export default function Projects() {
  return (
    <section className="projects" id="projects">
      <header className="projectsHeader">
        <h2 className="projectsTitle">Selected projects</h2>
        <p className="projectsIntro">
          Independent products and experiments focused on real user problems, kept separate from enterprise client work.
        </p>
      </header>

      <div className="projectsGrid">
        {projects.map((p, idx) => (
          <article className="projectCard" key={idx}>
            <ProjectImage project={p} />

            <div className="projectBody">
              <div className="projectTitleRow">
                <h3 className="projectName">{p.title}</h3>
                {p.status ? <span className="projectStatus">{p.status}</span> : null}
              </div>
              <p className="projectDesc">{p.description}</p>

              <div className="projectTags">
                {p.tags.map((t) => (
                  <span className="tag" key={t}>{t}</span>
                ))}
              </div>

              <div className="projectLinks">
                {p.links.github && (
                  <a className="linkBtn" href={p.links.github} target="_blank" rel="noopener noreferrer">
                    GitHub
                  </a>
                )}
                {p.links.demo && (
                  <a className="linkBtn" href={p.links.demo} target="_blank" rel="noopener noreferrer">
                    {p.links.demoLabel || "View project"}
                  </a>
                )}
                {!p.links.github && !p.links.demo ? (
                  <span className="linkBtn linkBtnMuted">Read more soon</span>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
